import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  Menu,
  withStyles,
} from "@material-ui/core";
import React from "react";
import {
  AddCircleOutline as AddCircleOutlineIcon,
  HighlightOffRounded as HighlightOffRoundedIcon,
} from "@material-ui/icons";

import "./style.css";
import { isEmpty, isFunction, isArray } from "lodash";

const StyledCheckBox = withStyles({
  root: {
    color: "#212f3c",
    "&$checked": {
      color: "#212f3c",
    },
  },
  checked: {},
})(Checkbox);

const SelectedItemView = ({ options, values }) => {
  return (
    Array.isArray(options) &&
    Array.isArray(values) &&
    values.map((current) => {
      const metaObj = options.find((temp) => current === temp.value);
      const label = metaObj.label ?? "No Label";
      return (
        <span key={current} className="seleted-values">
          {label}
        </span>
      );
    })
  );
};

const MultiSelectFilterInput = ({ meta, value = [], onChange }) => {
  const [anchorElement, setAnchorElement] = React.useState(null);

  const handleClose = () => {
    setAnchorElement(null);
  };

  const handleClick = (event) => {
    setAnchorElement(event.currentTarget);
  };

  const label = meta.label;
  const elementId = meta.elementId;
  const options = meta.options;

  const menuElementId = `${elementId}-menu`;
  const buttonElementId = `${elementId}-button`;
  const showMenuDropdown = Boolean(anchorElement);

  return (
    <Grid container direction="row" className="multi-select-filter-input">
      <Button
        id={buttonElementId}
        variant="contained"
        size="medium"
        className="outer-action-button"
        startIcon={
          isEmpty(value) ? (
            <AddCircleOutlineIcon />
          ) : (
            <HighlightOffRoundedIcon
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                if (isFunction(onChange)) {
                  onChange([]);
                }
              }}
            />
          )
        }
        aria-controls={showMenuDropdown ? menuElementId : undefined}
        aria-haspopup="true"
        aria-expanded={showMenuDropdown ? "true" : undefined}
        disableElevation
        onClick={handleClick}
      >
        {label}
        {!isEmpty(value) && (
          <SelectedItemView values={value} options={options} />
        )}
      </Button>
      <Menu
        id={menuElementId}
        anchorEl={anchorElement}
        elevation={2}
        keepMounted
        open={showMenuDropdown}
        onClose={handleClose}
        variant="selectedMenu"
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "center", horizontal: "left" }}
        PaperProps={{ style: { paddingInline: 8 } }}
        autoFocus
        slotProps={{
          list: {
            "aria-labelledby": buttonElementId,
          },
        }}
      >
        <Grid
          container
          direction="column"
          className="menu-content-container gap-y-8"
        >
          <FormGroup>
            {Array.isArray(options) &&
              options.map((option) => (
                <FormControlLabel
                  key={option.value}
                  control={
                    <StyledCheckBox
                      value={option.value}
                      size="small"
                      checked={
                        isArray(value) ? value.includes(option.value) : false
                      }
                      onChange={(event) => {
                        if (!Array.isArray(value) || !isFunction(onChange)) {
                          return;
                        }
                        const isChecked = event.target.checked;
                        const itemValue = option.value;
                        let output = [...value];
                        if (isChecked && !value.includes(itemValue)) {
                          output.push(itemValue);
                        }
                        if (!isChecked && value.includes(itemValue)) {
                          output = output.filter(
                            (current) => current !== itemValue,
                          );
                        }
                        onChange(output);
                      }}
                    />
                  }
                  label={option.label}
                />
              ))}
          </FormGroup>
        </Grid>
      </Menu>
    </Grid>
  );
};

export default MultiSelectFilterInput;
